module.exports = __webpack_public_path__ + "img/akusherstij-stacioner3.55d3e04e.jpg";